import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';
import { AppInformationService } from '../app-information.service';
import { Response } from '../model/response';

@Injectable()
export class UtilityService {
    static serviceName: string;

    constructor(private http: HttpClient, private appInfo: AppInformationService) {
        UtilityService.serviceName = environment.serviceName;
    }

    async getServiceVersion() {
        const result = await this.http.post(`${UtilityService.serviceName}/utility/getServiceVersion`, {}).toPromise();
        return result;
    }

    async getNextNumber(name: string) {
        const result = await this.http.post(`${UtilityService.serviceName}/utility/getNextNumber`, { name }).toPromise();
        return result as number;
    }

    async createInvoices(loadIds: number[]) {
        return await firstValueFrom(this.http.post<Response>(`${UtilityService.serviceName}/utility/createInvoices`, { loadIds: loadIds }));
    }

    async sendEmail(emailMessageId: number) {
        return await firstValueFrom(this.http.post<{ success: boolean; message: string }>(`${UtilityService.serviceName}/utility/sendEmail`, { emailMessageId }));
    }

    async sendToQueue(invoiceIds: number[]) {
        return await firstValueFrom(this.http.post<{ success: boolean; message?: string }>(`${UtilityService.serviceName}/utility/addEmailToQueue`, { invoiceIds }));
    }

    async sendStatementsToQueue(customerIds: number[]) {
        return await firstValueFrom(this.http.post<{ success: boolean; message?: string }>(`${UtilityService.serviceName}/utility/sendStatementsToQueue`, { customerIds }));
    }

    async sendMassCustomerEmailToQueue(emailMessageId: number) {
        return await firstValueFrom(this.http.post<{ success: boolean; message?: string }>(`${UtilityService.serviceName}/utility/sendMassCustomerEmailToQueue`, { emailMessageId }));
    }
}
